import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './report.reducers';

export const selectReportState = (state: AppState) => state.report;

export const {
  selectRequestId,
  selectReportName,
  selectFormat,
  selectParameters,
  selectFilename,
  selectHasNoParameters,
  selectPendingRequests,
} = createChildSelectors(selectReportState, initialState);
